module.exports = {
  hero: {
    title: "AI‑powered mobile app development",
    description:
      "We’re a software development studio specialized in fast, high-quality cross‑platform mobile apps (React Native). We use modern AI tooling to move faster—from design to build to release—without sacrificing polish.",
    bgImage: "img/app-hero-bg.jpg"
  },
  promo: {
    title: "Why small business owners love Katana Tech Team?",
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Affordable Development",
        description:
          "Our app development basic price is only $499. At this rate you can get a FULL app package and rapidly share your app with the world.",
        icon: "ti-vector text-white"
      },
      {
        title: "Get on-line fast",
        description:
          "Many app development firms take days or even weeks to build and publish your app. We can develop your app in hours. Seriously.",
        icon: "ti-lock text-white"
      },
      {
        title: "One-stop shop",
        description:
          "Don't know anything about mobile app publishing on App Store or Google Play store? Let us take care of the publishing stuff and allow you to run your business!",
        icon: "ti-eye text-white"
      }
    ]
  },
  aboutUs: {
    title: {
      bold: "Use your android or ios device",
      normal: ""
    },
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Clean Design",
        description:
          "Increase sales by showing true dynamics of your website",
        icon: "ti-vector text-white"
      },
      {
        title: "Secure Data",
        description:
          "Build your online store’s trust using Social Proof & Urgency",
        icon: "ti-lock text-white"
      },
      {
        title: "Retina Ready",
        description:
          "Realize importance of social proof in customer’s purchase decision",
        icon: "ti-eye text-white"
      }
    ]
  },
  price: {
    title: "Pricing Packages",
    description:
      "Uniquely maintain efficient expertise whereas cross functional deliverables. Continually leverage other's competitive mind share whereas enabled channels. ",
    packages: [
      {
        price: "$499",
        license: "Basic",
        isFeatured: false,
        features: [
          "Basic app including 1-3 screens",
          "App Store or Google Play Store submission",
          "",
          "-",
          "-",
          "-",
          "-",
          "-"
        ]
      },
      {
        price: "$999",
        license: "Popular",
        isFeatured: true,
        features: [
          "Standard app including 3-5 screens",
          "App Store submission",
          "Google Play Store submission",
          "App store optimization (ASO)",
          "App icon design", 
          "-",
          "-"
        ]
      },
      {
        price: "$1499+",
        license: "Premium",
        isFeatured: false,
        features: [
          "Premium app including 5-20 screens",
          "App Store submission",
          "Google Play Store submission",
          "App store optimization (ASO)",
          "App icon design",
          "Splash scren design",
          "Premium features"
        ]
      }
    ]
  },
  testimonial: {
    title: "What customer say about us",
    description:
      'Rapidiously morph transparent internal or "organic" sources whereas resource sucking e-business. Conveniently innovate compelling internal.',
    comments: [
      {
        name: "Arabella Ora",
        company: "AgencyCo",
        image: "img/client-2.jpg",
        comment:
          "Completely build backend ROI whereas cross-media metrics. Collaboratively deploy customer directed web-readiness via global testing procedures. Appropriately reinvent distributed innovation without proactive catalysts for change. Distinctively."
      },
      {
        name: "John Charles",
        company: "ThemeTags",
        image: "img/client-1.jpg",
        comment:
          "If you can design one thing you can design everything with Front. Just believe it. Collaboratively repurpose performance based e-commerce without cost. It's beautiful and the coding is done quickly and seamlessly."
      },
      {
        name: "Jeremy Jere",
        company: "WorldCheck",
        image: "img/client-3.jpg",
        comment:
          "The template is really nice and offers quite a large set of options. It's beautiful and the coding is done. If you can design one thing you can design everything with Front. Just believe it."
      },
      {
        name: "Ciaran Kierce",
        company: "AppCo",
        image: "img/client-4.jpg",
        comment:
          "I just wanted to share a quick note and let you know that you guys do a really good job. I’m glad I decided to work with you. It’s really great how easy your websites are to update and manage. I never have any problem at all."
      }
    ]
  },
  contact: {
    title: "Contact with us",
    description:
      "It's very easy to get in touch with us. Just use the contact form or pay us a visit for a coffee at the office.",
    // phone: "+63 9856 5831 830",
    email: "katanatechteam@gmail.com"
  },
  trustedCompany: [
    "img/client-1-color.png",
    "img/client-6-color.png",
    "img/client-3-color.png",
    "img/client-4-color.png",
    "img/client-5-color.png"
  ],
  trustedCompanyGray: [
    "img/client-1-gray.png",
    "img/client-2-gray.png",
    "img/client-3-gray.png",
    "img/client-4-gray.png",
    "img/client-5-gray.png"
  ],
  trustedCompanyAboutUs: {
    title: "We use the top rated libraries and packages",
    // description: "Rapidiously morph transparent internal or \"organic\" sources whereas resource sucking e-business. Conveniently innovate compelling internal.",
    companies: [
      "img/library-1.png",
      "img/library-2.png",
      "img/library-3.png",
      "img/library-4.png",
      "img/library-5.png",
      "img/library-6.png",
      // "img/library-7.png",
      // "img/library-8.png",
      // "img/library-9.png",
      // "img/library-10.png"
    ]
  },
  apps: {
    title: "Our apps in the stores",
    description:
      "We ship and maintain real products. Browse our published apps on Google Play and the App Store, and see the quality we deliver.",
    developerLinks: {
      googlePlay:
        "https://play.google.com/store/apps/developer?id=Katana+Tech+Team",
      appStore:
        "https://apps.apple.com/au/developer/alfredo-scarano/id1440205602"
    },
    items: [
      {
        name: "Currency & Crypto Converter",
        description:
          "Live exchange rates for currencies and crypto with a lightweight, fast UI.",
        image: "img/apps/currency-1.png",
        screenshots: [
          "img/apps/currency-1.png",
          "img/apps/currency-2.png",
          "img/apps/currency-3.png",
          "img/apps/currency-4.png"
        ],
        googlePlay:
          "https://play.google.com/store/apps/details?id=com.currencyapp",
        appStore: "https://apps.apple.com/app/id1440368328"
      },
      {
        name: "Dogs Pedia: Breed Identifier",
        description:
          "A dog breed encyclopedia with identification features and filters.",
        image: "img/apps/dogspedia-1.png",
        screenshots: [
          "img/apps/dogspedia-1.png",
          "img/apps/dogspedia-2.png",
          "img/apps/dogspedia-3.png",
          "img/apps/dogspedia-4.png"
        ],
        appStore:
          "https://apps.apple.com/kw/app/dogs-pedia-breed-identifier/id1498410213"
      },
      {
        name: "Cats Pedia: Breed Identifier",
        description:
          "A cat breed encyclopedia with identification features and search.",
        image: "img/apps/catspedia-1.png",
        screenshots: [
          "img/apps/catspedia-1.png",
          "img/apps/catspedia-2.png",
          "img/apps/catspedia-3.png",
          "img/apps/catspedia-4.png"
        ],
        appStore:
          "https://apps.apple.com/au/app/cats-pedia-breed-identifier/id1501298136"
      },
      {
        name: "Cocktails App: Drinks Database",
        description:
          "1,000+ cocktail recipes with filters, techniques, and a shopping list.",
        image: "img/apps/cocktails-1.png",
        screenshots: [
          "img/apps/cocktails-1.png",
          "img/apps/cocktails-2.png",
          "img/apps/cocktails-3.png",
          "img/apps/cocktails-4.png"
        ],
        appStore:
          "https://apps.apple.com/ga/app/cocktails-app-drinks-database/id1514997274"
      }
    ]
  },
  teamMember: {
    members: [
      {
        name: "Alfredo",
        designation: "React-native developer",
        image: "img/team-4.jpg",
        social: true
      },
      // {
      //   name: "Sophie",
      //   designation: "Senior Designer",
      //   image: "img/team-3.jpg"
      // },
      // {
      //   name: "Alex",
      //   designation: "Rect-native developer",
      //   image: "img/team-1.jpg"
      // },
      // {
      //   name: "Katie",
      //   designation: "App designer - ASO Specialist",
      //   image: "img/team-2.jpg"
      // }
    ]
  },
  video: {
    link: "https://www.youtube.com/watch?v=9No-FiEInLA"
  }
};
